/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/dtp-zusatzdaten-editor/shop.dtp-zusatzdaten-editor.component.ts.
 */
import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {WarenkorbEntry} from '../../../../models/warenkorb-entry';
import {BestellungEntry} from '../../../../models/bestellung-entry';
import {BehaviorSubject} from 'rxjs';

/**
 * Zweck: Beschreibt class ShopDtpZusatzdatenEditorComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
  selector: 'shop-dtp-zusatzdaten-editor',
  templateUrl: 'shop.dtp-zusatzdaten-editor.component.html',
  styleUrls: ['shop.dtp-zusatzdaten-editor.component.scss'],
  standalone: false
})
export class ShopDtpZusatzdatenEditorComponent implements OnInit, OnChanges {
  @Input() editMode = false;
  @Input() entry: WarenkorbEntry|BestellungEntry;
  @Output() entryChange = new EventEmitter<WarenkorbEntry|BestellungEntry>();
  @Input() warenkorbId: number;
  @Input() bestellungId: number;
  @Input() disabled = false;
  @Output() dataChanged = new EventEmitter();
  @Output() fieldChange = new EventEmitter();

  editAllOk = new BehaviorSubject<boolean>(false);

  modes = [
    {
      id: 'Erstverschreibung',
      label: 'Erstverschreibung',
    },
    {
      id: 'Folgeverschreibung',
      label: 'Folgeverschreibung',
    },
  ];

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit() {
    this.init();
  }

/**
 * Beschreibt Methode ngOnChanges und ihren Rückgabevertrag.
 */
  ngOnChanges(changes: SimpleChanges) {
    this.init();
  }

/**
 * Beschreibt Methode _fieldChange und ihren Rückgabevertrag.
 */
  _fieldChange() {
    this.fieldChange.emit();
  }

/**
 * Beschreibt Methode init und ihren Rückgabevertrag.
 */
  init() {
    let hasDefects = false;

    if (this.entry && this.entry.dtpZusatzdaten) {
      this.entry.dtpZusatzdaten.some(z => {
        if (z.defect == true) {
          hasDefects = true;
          return true;
        } else {
          return false;
        }
      });
    }

    this.editAllOk.next(hasDefects);
  }

/**
 * Beschreibt Methode _change und ihren Rückgabevertrag.
 */
  _change() {
    this.entryChange.emit(this.entry);
    this.dataChanged.emit();
  }

/**
 * Beschreibt Methode trackById und ihren Rückgabevertrag.
 */
  trackById(a, b) {
    return a;
  }
}
